import script from "./HomeActionBox.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeActionBox.vue?vue&type=script&setup=true&lang=js"

import "./HomeActionBox.vue?vue&type=style&index=0&id=77933672&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77933672"]])

export default __exports__